import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Tooltip } from '@material-ui/core';
import FlagIcon from '@material-ui/icons/Flag';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
    icon: {
        color: theme.palette.primary.main,
    },
}));

/**
 * Competition Design System — the ONE indicator for National Team
 * membership. Deliberately NOT built on StatusBadge/StatusPresentation:
 * this is a standalone boolean classification, never a
 * CompetitionAttendanceStatus value and never routed through the
 * multi-value status registry (see api/docs/ATTENDANCE.md). Icon + tooltip,
 * not color alone — accessible the same way attendance badges are.
 *
 * Reused everywhere an athlete's national-team classification is shown —
 * AthleteStatusLabel (plain-text contexts) and CompetitorCard (bracket,
 * results, shooting, final results) both render this SAME component, so
 * there is exactly one place this visual exists.
 */
const NationalTeamBadge = ({ size, className }) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const label = t('attendance.nationalTeam.tooltip', 'National Team Member');

    return (
        <Tooltip title={label}>
            <FlagIcon
                className={[classes.icon, className].filter(Boolean).join(' ')}
                style={{ fontSize: 'sm' === size ? 14 : 18 }}
                aria-label={label}
                data-testid='national-team-badge'
            />
        </Tooltip>
    );
};

NationalTeamBadge.propTypes = {
    size: PropTypes.oneOf(['sm', 'md']),
    className: PropTypes.string,
};

NationalTeamBadge.defaultProps = {
    size: 'sm',
    className: null,
};

export default NationalTeamBadge;
